/* RESPONSIBLE TEAM: team-data-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/require-snake-case-analytics */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable promise/prefer-await-to-then */
/* eslint-disable ember/no-controllers */
/* eslint-disable ember/no-classic-classes */
import { reads } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Controller, { inject as controller } from '@ember/controller';
import { action } from '@ember/object';

export default Controller.extend({
  intercomEventService: service(),
  appController: controller('apps.app'),
  app: reads('appController.model'),
  // eslint-disable-next-line @intercom/intercom/no-legacy-modal
  modalService: service(),
  usersOrLeads: 'users',

  openTaggingModal: action(function (component, model, options) {
    this.modalService.openModal(component, model, options);
  }),

  actions: {
    completeImport() {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'mailchimp-import-initiated',
        object: 'mailchimp-import',
      });
      this.model.completeFor(this.get('app.id')).then(() => {
        this.transitionToRoute('apps.app.import.mixpanel.finish', this.model);
      });
    },
  },
});
